module.exports = __webpack_public_path__ + "media/images/icons/v2/calendar-fad1837d30c8299f58c8d1b46f479e93.svg";